import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllImportMutasiBank = createAsyncThunk(
  "importMutasiBank/GetAllImportMutasiBank",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}mutasi_bank/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleImportMutasiBank = createAsyncThunk(
  "importMutasiBank/GetSingleImportMutasiBank",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}mutasi_bank/get_by_id/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const importMutasiBankSlice = createSlice({
  name: "importMutasiBank",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all importMutasiBank
    builder.addCase(GetAllImportMutasiBank.pending, loadingHandler);
    builder.addCase(GetAllImportMutasiBank.fulfilled, fulfilledHandler);
    builder.addCase(GetAllImportMutasiBank.rejected, rejectedHandler);
    // fetch importMutasiBank by id
    builder.addCase(GetSingleImportMutasiBank.pending, loadingHandler);
    builder.addCase(GetSingleImportMutasiBank.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleImportMutasiBank.rejected, rejectedHandler);
  },
});

export const { reset } = importMutasiBankSlice.actions;
export default importMutasiBankSlice.reducer;
